import {
  ControlLabel,
  FormControl,
  FormGroup,
  HelpBlock,
  InputGroup
} from "react-bootstrap";
import React, { Fragment } from "react";

import Addon from "./Addon";
import CategorySelect from "../../components/Category/CategorySelect";
import CurrencyInput from "../../components/Currency/CurrencyInput";
import { DatePicker as DatePickerComponent } from "./DateField.jsx";
import Switch from "react-bootstrap-switch";
import TagArticleSelect from "../../components/Article/TagArticleSelect";
import TierSelect from "../../components/Tier/TierSelect";

export const Label = props => <ControlLabel>{props.children}</ControlLabel>;

const InputAddon = props => {
  let clonedProps = { ...props.control };
  const ControlComponent = props.control;
  const addon = props.addon;
  delete clonedProps.addon;
  return (
    <InputGroup>
      {addon.position === "left" && <Addon {...addon} />}
      <ControlComponent {...props} />
      {addon.position === "right" && <Addon {...addon} />}
    </InputGroup>
  );
};

const Input = props => {
  const ControlComponent = props.control;
  return (
    <FormGroup validationState={props.error ? "error" : null}>
      {props.label && (
        <Label>
          {props.label} {props.required && <span className="star">*</span>}
        </Label>
      )}
      {props.addon ? (
        <InputAddon {...props} />
      ) : (
        <ControlComponent {...props} />
      )}
      {props.error && (
        <React.Fragment>
          {/* <FormControl.Feedback /> */}
          <HelpBlock>
            <div>{props.error}</div>
          </HelpBlock>
        </React.Fragment>
      )}
    </FormGroup>
  );
};

export const Block = props => (
  <div className={props.className ? props.className : ""}>{props.content}</div>
);

export const TextArea = props => (
  <FormControl
    onChange={props.onChange}
    componentClass="textarea"
    placeholder={
      props.placeholderId
        ? props.intl.formatMessage({ id: props.placeholderId })
        : ""
    }
    value={props.value || ""}
    name={props.name || ""}
    style={{ minHeight: "90px" }}
  />
);

export const TextField = props => (
  <FormControl
    onChange={props.onChange}
    placeholder={props.placeholder || ""}
    value={props.value || ""}
    name={props.name || ""}
  />
);

export const CurrencyField = props => (
  <CurrencyInput
    currencyId={props.currency.id || props.currency}
    value={props.value}
    update={event => props.update(props.name, event.value)}
  />
);

export const DatePicker = props => (
  <DatePickerComponent
    onChange={props.onChange}
    placeholder={props.placeholder || ""}
    value={props.value || null}
    name={props.name || ""}
    locale={props.locale}
  />
);

export const Select = props => (
  <FormControl
    componentClass="select"
    name={props.name}
    value={props.value || ""}
    onChange={props.onChange}>
    {(props.blank || !props.value) && <option value="" />}>
    {props.options.map((option, i) => (
      <option key={`options-${i}`} value={option.value}>
        {option.text}
      </option>
    ))}
  </FormControl>
);

export const SelectCollaborator = props => (
  <TierSelect
    companyId={props.companyId}
    showCollaborators={true}
    showClients={false}
    showSuppliers={false}
    showComptables={false}
    value={props.value || ""}
    name={props.name || ""}
    onSelected={e =>
      props.onChange({ target: { name: props.name, value: e && e.value } })
    }
  />
);

export const SelectClient = props => (
  <TierSelect
    companyId={props.companyId}
    showClients
    showCollaborators={false}
    showSuppliers={false}
    showComptables={false}
    value={props.value || ""}
    name={props.name || ""}
    onSelected={e =>
      props.onChange({ target: { name: props.name, value: e && e.value } })
    }
  />
);

export const SelectCategory = props => (
  <CategorySelect
    companyId={props.companyId}
    value={props.value || ""}
    expenseCategory={false}
    supplierCategory={false}
    collaboratorCategory={false}
    clientCategory={false}
    tiersCategory={false}
    invoiceCategory={true}
    onSelected={e =>
      props.onChange({ target: { name: props.name, value: e && e.value } })
    }
  />
);

export const SelectTagArticle = props => (
  <TagArticleSelect
    value={props.value || ""}
    companyId={props.companyId}
    options={props.options}
    onSelected={e => {
      props.onChange({ target: { name: props.name, value: e && e.value } });
    }}
    clearable
    creatable
  />
);

export const Toggle = props => (
  <Fragment>
    <Switch
      onText=""
      offText=""
      value={props.value || false}
      onChange={(elm, state) =>
        props.onChange({ target: { name: props.name, value: state } })
      }
    />
    <span style={{ marginLeft: "10px" }}>
      {props.value && props.labels
        ? props.intl.formatMessage({ id: props.labels.isTrue }).toUpperCase()
        : props.intl.formatMessage({ id: props.labels.isFalse }).toUpperCase()}
    </span>
  </Fragment>
);

class SForm extends React.Component {
  render() {
    return null;
  }
}

SForm.Input = Input;
SForm.DatePicker = DatePicker;

export default SForm;
